<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PTCCTV }}</h2>

        <div class="mb-3">
            {{ store.lexicon[store.culture].PTCCTV1 }}
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PTCCTV2 }}</label>
                <input type="text" class="form-control" v-model="store.formData.Cctv.CaseNumber" @@blur="updateCaseNumber" />
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PTCCTV3 }}<span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Cctv.Location" @input="validatePage('CCTV', 'location')" />
                <div v-if="store.errors.Cctv.Location" class="error">{{ store.lexicon[store.culture].PTCCTV4 }}</div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PTCCTV5 }}<span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Cctv.IncidentDate" :enable-time-picker="false" auto-apply model-type="format" format="MM/dd/yyyy"></VueDatePicker>
                <!--<bootstrap-datetime-picker :options="dtPickerOptions" v-model="formData.Cctv.IncidentDate"></bootstrap-datetime-picker>-->
                <div v-if="store.errors.Cctv.IncidentDate" class="error">{{ store.lexicon[store.culture].PTCCTV6 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PTCCTV7 }}<span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Cctv.IncidentTime" time-picker auto-apply model-type="format" format="hh:mm aa" :is-24="false"></VueDatePicker>
                <!--<input type="text" class="form-control" v-model="formData.Cctv.IncidentTime" @@input="validatePage('CCTV', 'incidentTime')" @@blur="updateTimeOfIncident" />-->
                <div v-if="store.errors.Cctv.IncidentTime" class="error">{{ store.lexicon[store.culture].PTCCTV8 }}</div>
            </div>
        </div>
        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PTCCTV9 }}<span class="required">*</span></label>
            <textarea type="text" class="form-control" v-model="store.formData.Cctv.Details" @input="validatePage('CCTV', 'details')"></textarea>
            <div v-if="store.errors.Cctv.Details" class="error">{{ store.lexicon[store.culture].PRPolice15 }}</div>
        </div>

        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PTCCTV11 }} <span class="required">*</span></label>
            <textarea type="text" class="form-control" v-model="store.formData.Cctv.Reason" @input="validatePage('CCTV', 'reason')"></textarea>
            <div v-if="store.errors.Cctv.Reason" class="error">{{ store.lexicon[store.culture].PTCCTV12 }}</div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.currentTypePage == 0 ? goBackToPage('TYPE') : goBackToTypePage(store.currentTypePage - 1)">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="store.currentTypePage == store.formData.Types.length - 1 ? goToPage('FINISH') : goToTypePage(store.currentTypePage + 1)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage', 'goBackToTypePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }

</script>